export default class CompanyConfig {
	constructor({company_id, company_name, config_json, id, type_config_id}) {
		this.company_id = company_id || 0;
		this.company_name = company_name || "";
		this.config_json = config_json || {};
		this.id = id || 0;
		this.type_config_id = type_config_id || 0;
	}
}
